// extracted by mini-css-extract-plugin
export default {"tags-container":"TagsContainer_tags-container__NbU+x","tags-container__inner":"TagsContainer_tags-container__inner__dQy7T"};